export default __webpack_public_path__ + "static/ranger-7700adbc4e12a5e068e21c666b9223e8.jpg";